module.exports = function(bootstrap) {
    bootstrap.run(["Service","sessionData", function (Service,sessionData) {
        return new Service({
            name: 'claimSummary',
            group: "eprsvc",
            url: "/eprsvc/x-services/secure/claims/v1/summary",
           
            fetch: function(agreementId,umi,groupNumber,startDate,endDate){
                console.log("for  claims summary ",sessionData.clientNumber)
                    if(sessionData && sessionData.basicInfo && sessionData.basicInfo.role && sessionData.basicInfo.role.toLowerCase() == "mcu_admin") {
                        if(sessionData.clientNumber && sessionData.clientNumber !== undefined){
                            this.headers['ClientNumber']  = sessionData.clientNumber;
                            console.log("for MCU claims summary ",sessionData.clientNumber )
                        }
                    }
                return this.get({
                    agreementId : agreementId,
                    umi : umi,
                    startDate : startDate,
                    endDate : endDate,
                    //groupNumber : groupNumber
                });
            }
        });
    }]);
};
